// extracted by mini-css-extract-plugin
var _1 = "checked__sgTue";
var _2 = "switcher__yCPxG";
var _3 = "switcherWrapper__fD2HD";
var _4 = "thumb__iggkK";
export { _1 as "checked", _2 as "switcher", _3 as "switcherWrapper", _4 as "thumb" }
export default { "checked": _1, "switcher": _2, "switcherWrapper": _3, "thumb": _4 }
